import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppGlobals } from '@app/app.global';
import { 
  HyperpureOrder, 
  OrdersResponse, 
  OrderResponse, 
  InvoiceUrlResponse 
} from '@modules/hyperpure/interfaces';

@Injectable({
  providedIn: 'root'
})
export class HyperpureOrderService {

  constructor(private http: HttpClient, private appGlobals: AppGlobals) { }

  getOrders(params: {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: string;
    status?: string;
    buyer_account_id?: number;
    buyer_outlet_id?: number;
    entityId?: string;
  }): Observable<OrdersResponse> {
    let httpParams = new HttpParams();
    
    // Extract entityId for headers
    const entityId = params.entityId;
    
    Object.keys(params).forEach(key => {
      // Skip entityId as it goes in header, not query params
      if (key === 'entityId') return;
      
      const value = params[key as keyof typeof params];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    // Add x-entity-ids header if entityId is provided
    const headers = entityId ? { 'x-entity-ids': entityId } : {};

    return this.http.get<OrdersResponse>(
      `${this.appGlobals.apiUrl.dashboard}/hyperpure/orders`, 
      { params: httpParams, headers }
    );
  }

  getOrderByNumber(orderNumber: string): Observable<OrderResponse> {
    return this.http.get<OrderResponse>(`${this.appGlobals.apiUrl.dashboard}/hyperpure/orders/${orderNumber}`);
  }

  getInvoiceSignedUrl(orderNumber: string, invoiceType: string = 'combined'): Observable<InvoiceUrlResponse> {
    return this.http.get<InvoiceUrlResponse>(`${this.appGlobals.apiUrl.dashboard}/hyperpure/orders/${orderNumber}/invoice/${invoiceType}`);
  }

  downloadInvoice(orderNumber: string, invoiceType: string = 'combined'): void {
    this.getInvoiceSignedUrl(orderNumber, invoiceType).subscribe({
      next: (response) => {
        if (response.success && response.data.signedUrl) {
          window.open(response.data.signedUrl, '_blank');
        }
      },
      error: (error) => {
        console.error('Error downloading invoice:', error);
      }
    });
  }
}
